import React, { Component } from 'react';
import { Switch } from 'react-router-dom'
import Grid from './grid'
import Form from './form'
import PrivateRoute from '../../containers/PrivateRoute'

class Automacao extends Component {
	render() {
		return (
			<div className="hdv-render-div">
				<div className="col-md-12 hdv-bloco-top-space hdv-zera-padding-left-right-boostrap">
					<Switch>
						<PrivateRoute exact path='/automacao' component={Grid} />
						<PrivateRoute path='/automacao/novo' component={Form} />
						<PrivateRoute path='/automacao/:id/editar' component={Form} />
					</Switch>
				</div>
			</div>
		);
	}
}

export default Automacao;
